<template>
  <main class="main main--has-floating-buttons grid--dense grid--min-height">
    <card title="Tenant" cols="12 6@desktop">
      <hm-card-inner>
        <hm-input v-if="hotelSettings.hotel.whiteLabel === 'Hotelmeister'"
                  :lazy="true"
                  v-model="newTenant.subdomain"
                  label="Instance Name"
                  validate="regex:^[a-zA-Z0-9][a-zA-Z0-9\-]+$" />
        <hm-input :lazy="true"
                  v-model="newTenant.hotelName"
                  label="Hotel Name"
                  validate="required|min_length:4" />
        <hm-input :lazy="true"
                  v-model="newTenant.city"
                  label="City"
                  validate="required|min_length:4" />
        <hm-select :lazy="true"
                   v-model="newTenant.countryCode"
                   :options="getI18nCountries($shortLocale)"
                   validate="required"
                   label="Country"/>
        <hm-input-number v-model="newTenant.numberOfRooms"
                         label="Room Count"
                         validate="required|min_value:0" />
        <hm-multiselect v-model="newTenant.featureBundles"
                        :options="featureBundles"
                        label="License Bundle"
                        name="featureBundles"
                        label-expression="${option.name}" />
      </hm-card-inner>
      <hm-card-inner label="White-Label Billing">
        <hm-input :lazy="true" v-model="newTenant.externalAccountId" label="External Account ID" help="Required for billing (White Label Partners only)" />
      </hm-card-inner>
    </card>

    <hm-floating-buttons ref="floatingButtons">
      <hm-floating-button :throttle="30000"
                          :disabled="!canCreate"
                          label="Create Tenant"
                          icon="save"
                          color="green"
                          @click="createTenant" />
    </hm-floating-buttons>

  </main>
</template>


<script>
/* eslint func-names: 0 */

import { isEmpty, isNil, last, isFunction, sortBy, head, lowerCase } from 'lodash';
import uuid from 'uuid';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import FilterMixin from '@/mixins/FilterMixin';
import HmCardInner from '../../lib/layout/HmCardInner';

export default {
  name: 'PageCreateTenant',
  components: { HmCardInner },
  mixins: [HotelmeisterMixin, FilterMixin],

  data() {
    return {
      newTenant: {
        subdomain: null,
        hotelName: null,
        city: null,
        countryCode: null,
        numberOfRooms: null,
        featureBundles: null,
        externalAccountId: null,
      },
    };
  },

  computed: {
    featureBundles: function () {
      return this.enums.FeatureBundle
        .filter(it => it.toLowerCase().indexOf('plan_') === 0)
        .filter((it) => {
          const whiteLabelPartners = this.enums.ADDITIONAL_DATA.FeatureBundle[it].whiteLabelPartners;
          if (isEmpty(whiteLabelPartners)) return true;
          else return whiteLabelPartners.includes(this.hotelSettings.hotel.whiteLabel);
        })
        .map(it => ({
          id: it,
          name: it,
        }));
    },
    canCreate() {
      if (isEmpty(this.newTenant.featureBundles)) return false;
      if (isEmpty(this.newTenant.countryCode)) return false;
      if (isEmpty(this.newTenant.hotelName)) return false;

      return true;
    },
  },

  watch: {
  },

  mounted: function () {
  },

  created: function () {
  },

  methods: {

    openHotel(hotel) {
      if (hotel.hotelId === this.$root.hotel) return;

      this.addUIBreadcrumb('User initiated hotel switch');

      const toRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).includes('__hotelSettings')) {
          toRemove.push(localStorage.key(i));
        }
      }
      toRemove.forEach(it => localStorage.removeItem(it));

      // eslint-disable-next-line no-undef
      setToken(hotel.hotelId, getToken(this.$root.hotel));
      // eslint-disable-next-line no-undef
      clearToken(this.$root.hotel);
      // this.$root.hotel = hotel.hotelId;
      this.$store.dispatch('hotel/setHotelId', hotel.hotelId);
      // this.$serviceBus.$emit('hotelSettings.update.immediate');
      // this.$root.logout();

      // eslint-disable-next-line no-undef
      const routeURL = this.$router.resolve({ name: 'hotels', params: { hotelId: hotel.hotelId }, query: { token: getToken(this.$root.hotel) } });
      window.location.href = routeURL.href;
    },
    createTenant() {
      this.axios.post(this.serviceUrls.tenant.create(), this.newTenant)
        .then((response) => {
          this.showMessages(response);
          this.openHotel({ hotelId: response.data.data.hotelId });
          this.$store.dispatch('hotel/updateAccessibleHotels');
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageCreateTenant.vue